import { FGCustomPanel, FGSelectInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGCountrySelect, FGSRSHDateMaskInput } from "../../../../components";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { RequestBreedTransientSelection } from "../../../../pages/request/request/item/RequestBreedTransientSelection";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";

export interface IDrupalKennelImportRequestFormProps {
  kennelImportRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalKennelImportRequestForm: React.FunctionComponent<IDrupalKennelImportRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const [kennelTypes, ktloading] = useReferential((a) => a.getKennelTypes(), false, []);

  return (
    <DrupalFormGenerator
      initialValues={initialdata}
      editMode={false}
      onSubmit={() => {}}
      loading={loading}
      saving={false}
      deleting={false}
      hideButtons
    >
      <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}>
        <div>
          <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} />
          {initialdata?.request?.status === ERequestState.EXECUTED && (
            <FieldGroup columns={2}>
              <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
            </FieldGroup>
          )}
        </div>
      </FieldGroup>
      <DrupalFieldSet title={t(ETLCodes.FileAffix)}>
        <FieldGroup columns={2}>
          <FGTextInput name="nameOffer" label={t(ETLCodes.NameOffer)} maxLength={29} forceCase={"upper"} />
          <FGSelectInput name="nameOfferType" label={t(ETLCodes.Affix)} items={kennelTypes} loading={ktloading} />
          <FGCountrySelect name="countryId" label={t(ETLCodes.CountryOfOrigin)} />
        </FieldGroup>
      </DrupalFieldSet>
      {/* <DrupalFieldSet title={t(ETLCodes.Owners)}>
        <FGCustomPanel>
          {({ formik }) => (
            <>
              <RequestTransientPersonSelection
                linkedIds={formik?.values?.transientOwnerIds || null}
                onLinkedIdsChanged={(ids) =>
                  formik?.setFieldValue("transientOwnerIds", ids)
                }
                editMode={false}
                loading={loading}
              />
            </>
          )}
        </FGCustomPanel>
      </DrupalFieldSet> */}
      <DrupalFieldSet title={t(ETLCodes.Breeds)}>
        <FGCustomPanel>
          {({ formik }) => (
            <>
              <RequestBreedTransientSelection
                linkedIds={formik?.values?.transientBreedIds || null}
                onLinkedIdsChanged={(ids) => formik?.setFieldValue("transientBreedIds", ids)}
                editMode={false}
                loading={loading}
              />
            </>
          )}
        </FGCustomPanel>
      </DrupalFieldSet>
      <DrupalStepperButtonBloc backOnly />
    </DrupalFormGenerator>
  );
};
